import { generateMutations } from '../builder'

export default {
  ...generateMutations('getTimes', 'times'),
  ...generateMutations('saveTime', 'time'),
  ...generateMutations('getTime', 'time'),
  ...generateMutations('deleteTime'),
}
